import { render, staticRenderFns } from "./AlertPanel.vue?vue&type=template&id=6965e5e6&scoped=true"
import script from "./AlertPanel.vue?vue&type=script&lang=js"
export * from "./AlertPanel.vue?vue&type=script&lang=js"
import style0 from "./AlertPanel.vue?vue&type=style&index=0&id=6965e5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6965e5e6",
  null
  
)

export default component.exports